import React from 'react';
import { Box } from '@mui/material';
import { useShowContext } from 'framework/show';
import { EmployeePersonTile } from 'domain/shared/core/PersonTile';
import { READ_EMPLOYEE_PERMISSION, useEmployeePermissionsMap } from 'domain/shared/employee';

import { ManagerData } from './types';
import { generateLinkByEmail } from 'framework/utils';

const ManagersList: React.FC = () => {
  const { data } = useShowContext<ManagerData[]>();
  const allManagers = data?.getData() || [];

  const aliases = allManagers.map(manager => manager.alias);
  const { permissionsMap } = useEmployeePermissionsMap(aliases);

  return (
    <Box>
      {allManagers.map(manager => {
        const isLink =
          Array.isArray(permissionsMap[manager.alias]) &&
          permissionsMap[manager.alias].includes(READ_EMPLOYEE_PERMISSION);

        return (
          <Box key={manager.alias} sx={{ mb: 2 }}>
            <EmployeePersonTile
              employeeId={manager.alias}
              title="People manager"
              size="medium"
              isLink={isLink}
              showTeamsButton
              teamsIconSize="medium"
              teamsUrl={generateLinkByEmail(manager.workingEmail as string)}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ManagersList;
